// ----------------------------------------------------------------------
// <copyright file="Izenda.OthersAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var mobx = require('mobx');
  var React = require('react');
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;
  const { curry, isEmpty } = require('lodash/fp');
  var commonMessages = require('share/messages/Izenda.CommonMessages');

  var OthersAction = compose(
    withHandlers({
      onSave: curry(onSave),
      onCancel: curry(onCancel)
    })
  );

  function onCancel(props, e) {
    var loader = props.loader;
    var store = props.store;
    var model = store.otherSettings;

    loader.startLoading();
    props
      .confirmDirtyForm(model.isDirty)
      .then(store.getInitial.bind(store))
      .finally(loader.endLoading.bind(loader));
  }

  function onSave(props, e) {
    var store = props.store;
    var loader = props.loader;
    var model = store.otherSettings;
    var localization = props.localization;
    model.alertMessage = commonMessages.EMPTY_MESSAGE;

    return props.validation
      .validate()
      .then(function(result) {
        if (result) {
          if (model.isDirty) {
            loader.startLoading();

            return props
              .confirmFn('Confirmation', {
                description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
              })
              .then(store.onSave.bind(store))
              .finally(loader.endLoading.bind(loader));
          } else {
            model.alertMessage = {
              type: 'info',
              message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
            };
          }
        }
      })
      .then(function(saveErrors) {
        if (!isEmpty(saveErrors)) {
          valManager.updateErrors(saveErrors);
        }
        return null;
      });
  }

  module.exports = OthersAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Others/Izenda.OthersAction.js